import { FIGHTERS, COMMENTARY } from "../data/fighters";

const SCORE_KEY = "meme-brawl-scorecard-v1";

export function loadScorecard() {
  try {
    const raw = localStorage.getItem(SCORE_KEY);
    if (!raw) return defaultScorecard();
    const parsed = JSON.parse(raw);
    return { ...defaultScorecard(), ...parsed };
  } catch {
    return defaultScorecard();
  }
}

export function saveScorecard(sc) {
  try {
    localStorage.setItem(SCORE_KEY, JSON.stringify(sc));
  } catch {
    /* ignore */
  }
}

export function defaultScorecard() {
  return {
    wins: 0,
    losses: 0,
    streak: 0,
    bestStreak: 0,
    knockouts: 0,
    perFighter: {}, // { fighterId: { wins, losses } }
  };
}

export function recordResult(sc, { playerId, won }) {
  const next = { ...sc, perFighter: { ...sc.perFighter } };
  const row = next.perFighter[playerId] || { wins: 0, losses: 0 };
  if (won) {
    next.wins += 1;
    next.streak += 1;
    next.knockouts += 1;
    next.bestStreak = Math.max(next.bestStreak, next.streak);
    row.wins += 1;
  } else {
    next.losses += 1;
    next.streak = 0;
    row.losses += 1;
  }
  next.perFighter[playerId] = row;
  saveScorecard(next);
  return next;
}

export function favoriteFighter(sc) {
  const entries = Object.entries(sc.perFighter);
  if (!entries.length) return null;
  const [id] = entries.sort(
    (a, b) => b[1].wins + b[1].losses - (a[1].wins + a[1].losses)
  )[0];
  return FIGHTERS.find((f) => f.id === id) || null;
}

// Core damage calc with randomness and crit chance
export function rollDamage(attacker, defender, kind = "punch", taunted = false) {
  const base = attacker.stats.atk;
  const def = defender.stats.def;
  const roll = 0.85 + Math.random() * 0.3; // 0.85 - 1.15
  let mult = 1;
  if (kind === "special") mult = 1.75;
  if (taunted) mult *= 1.5;
  const crit = Math.random() < (kind === "special" ? 0.25 : 0.12);
  if (crit) mult *= 1.5;
  const raw = base * mult * roll - def * 0.4;
  return { dmg: Math.max(4, Math.round(raw)), crit };
}

export function randomCommentary() {
  return COMMENTARY[Math.floor(Math.random() * COMMENTARY.length)];
}

export function tauntLine(fighter) {
  const t = fighter.taunts;
  return t[Math.floor(Math.random() * t.length)];
}

export function winLine(fighter) {
  const t = fighter.wins;
  return t[Math.floor(Math.random() * t.length)];
}
